import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';

interface ThirtyDayForecastMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ThirtyDayForecastMiniCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: ThirtyDayForecastMiniCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            30-Day Forecast
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">£312,850</div>
          <div className="flex items-center gap-1 text-xs mt-1">
            <TrendingUp className="h-3 w-3 text-green-500" />
            <span className="text-green-500">+8.8%</span>
            <span className="text-muted-foreground">vs current</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
